<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    multiple
    chips
    deletable-chips
    small-chips
    item-text="descricao"
    item-value="id"
    label="Centros de custo"
    class="rounded-tag-small"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    @change="onChange"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          <v-chip label small v-if="item.item.codigoInterno">
            {{ item.item.codigoInterno }}
          </v-chip>
          {{ item.item.descricao }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CentroCustoService from '@/api/centro-custo-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: [Object, Array],
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    buildFilter(val) {
      const text = val || '';
      const filter = `descricao like "%${text.toLowerCase()}%" or codigoInterno like "%${text.toLowerCase()}%"`;
      return `${filter} order by descricao`.trim();
    },
    searchItems(val) {
      this.loading = true;
      CentroCustoService.getCentroCustos({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildFilter(val),
      })
        .then((response) => {
          this.items = response.data.content;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
